module.exports = __webpack_public_path__ + "img/Path 13@3x.79034411.png";